import React from 'react';
import { Typography } from '@mui/material';
import { useInView } from 'react-intersection-observer';
import {
  StyledInlineGrid,
  StyledIndexedCircle,
  StyledImg,
  StyledImageNumberContainer,
  StyledInfo,
  StyledLine,
  StyledText,
} from './DS_InfoGraphicsCardStyles';

const DS_InfoGraphicCard = ({ card, index, enumeration, layoutVariant, isRichText }) => {
  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true,
    rootMargin: '-200px 0px 0px 0px',
  });

  const CardText = ({ title, subtitle }) => {
    return (
      <div>
        {title && (
          <Typography component="h3" variant="DS_copyBigBold">
            {title}
          </Typography>
        )}
        {subtitle && (
          <Typography component="p" variant="DS_labelSmallRegular">
            {subtitle}
          </Typography>
        )}
      </div>
    );
  };

  const Enumeration = ({ index, setInMiddle, className }) => {
    return (
      <StyledIndexedCircle setInMiddle={setInMiddle} className={className}>
        {' '}
        <Typography component="p" variant="DS_labelSmallBold">
          {index + 1}
        </Typography>
      </StyledIndexedCircle>
    );
  };

  return (
    <StyledInlineGrid $layoutVariant={layoutVariant} $index={index + 1} isRichText={isRichText}>
      <StyledImageNumberContainer>
        {enumeration && !(layoutVariant === 'Layout Path') && <Enumeration index={index} setInMiddle={false} />}
        {card.socialIcon && (
          <StyledImg
            $layoutVariant={layoutVariant}
            ref={ref}
            $index={index + 1}
            className={inView ? `icon-pic-drop-${index + 1}` : 'icon-pic'}
            width={180}
            height={180}
            src={card.socialIcon.file.url}
            alt={card.title || 'icon'}
            loading="lazy"
            isRichText={isRichText}
          />
        )}
      </StyledImageNumberContainer>
      {!(layoutVariant === 'Layout Path') && (
        <StyledInfo $layoutVariant={layoutVariant} isRichText={isRichText}>
          <CardText title={card.title} subtitle={card.subtitle} />
        </StyledInfo>
      )}
      {layoutVariant === 'Layout Path' && (
        <>
          {enumeration && <Enumeration index={index} setInMiddle={true} className="info-number" />}
          <StyledLine className={inView ? `line-draw` : 'line'}></StyledLine>
          <StyledText className="info-text">
            <CardText title={card.title} subtitle={card.subtitle} />
          </StyledText>
        </>
      )}
    </StyledInlineGrid>
  );
};

export default DS_InfoGraphicCard;
